import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import ZorgbaseResult from '@/app/api/filter/[postcode]/ZorgbaseResult';

interface ZorgbaseResultWithPostcodeLocation {
	results: ZorgbaseResult[];
	location: {
		postcode: string;
		lat: number;
		lon: number;
	};
}

export interface ApiResponseError {
	status: number;
	data: {
		message: string;
	}
}

export const api = createApi({
	baseQuery: fetchBaseQuery({
		baseUrl: '/api',
	}),
	tagTypes: [],
	endpoints: (builder) => ({
		// getOrganisation: builder.query<Array<string>, string>({
		// 	query: (id) => `/organisation/${id}`,
		// }),
		getZorgbase: builder.query<Array<ZorgbaseResult>, void>({
			query: () => '/zorgbase'
		}),
		getLandelijk: builder.query<Array<ZorgbaseResult>, void>({
			query: () => '/landelijk'
		}),
		findByPostcode: builder.query<ZorgbaseResultWithPostcodeLocation, string>({
			query: (postcode) => `/filter/${postcode}`,
		}),
		findByAGBCode: builder.query<ZorgbaseResult, string>({
			query: (agbCode) => `/agbcode/${agbCode}`,
		}),
	}),
});

// export hooks for usage in functional components
export const {
	useGetZorgbaseQuery,
	useGetLandelijkQuery,
	useFindByPostcodeQuery,
	useFindByAGBCodeQuery,
	util: { getRunningQueriesThunk },
} = api;

// export endpoints for use in SSR
export const {
	getZorgbase,
	getLandelijk,
	findByPostcode,
	findByAGBCode,
} = api.endpoints;
